module.exports = __webpack_public_path__ + "img/settings_edit_beacon_location.519bfd07.png";